/**Returns a map based on the given array. Similar to using .ToDictionary(x => key, x => value) in C#. */
export function arrayToMap<TSource, TKey, TValue>(array: TSource[], keySelector: (elem: TSource) => TKey, valueSelector: (elem: TSource) => TValue): Map<TKey, TValue> {
    const result = new Map<TKey, TValue>();
    for (let elem of array) {
        result.set(keySelector(elem), valueSelector(elem));
    }
    return result;
}